import { Ads, CustomClassContext } from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode, useContext } from "react";

import styles from "../category.module.css";
import SubAnchor from "../SubAnchor";
import { CategoryLayoutElementProps } from "../types/types";
import CategorySidebar from "./CategorySidebar";

export default function CategorySubAnchorBlock({
  data,
}: CategoryLayoutElementProps): ReactNode {
  const customClass = useContext(CustomClassContext);
  const sectionContainerClass = customClass?.categoryLayout?.sectionContainer;

  if (!data.latestArticle?.length) {
    return null;
  }

  return (
    <section className={cx(styles.bodyContainer, sectionContainerClass)}>
      <div className={styles.latestTeaserContainer}>
        <div className={styles.latestTeaserLayout}>
          <SubAnchor articleList={data.latestArticle} />
          <div className={styles.mobileAdvertisement}>
            <Ads.AdsSideBarMobile />
          </div>
        </div>

        <CategorySidebar data={data} />
      </div>
    </section>
  );
}
